// @flow

import StateListenerRegistry from '../../../react/features/base/redux/StateListenerRegistry';
import WildixEvents from '../../service/WildixEvents';

/**
 * Listens for changes in the full screen state to send analytics.
 */
StateListenerRegistry.register(
    /* selector */ state => state['features/base/connection'].error,
    /* listener */ (objectError, store) => {
        APP.wildix.eventEmitter.emit(WildixEvents.CONNECTION_ERROR, objectError);

        APP.conference.askReloadPage = false;
    }
);
